import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {TestOrderStatus} from 'graphql-client/__generated/graphqlGlobalTypes';
import {getOrderedTestOrderStatuses, TestOrderStatusDisplay} from 'sample-tests/ui/utils/TestOrderStatusUtil';
import SelectDropdown from 'ui-library/dropdowns/SelectDropdown';
import Menu from 'ui-library/menus/Menu';
import Option from 'ui-library/menus/Option';

interface TestOrderStatusDropdownProps {
  status: TestOrderStatus | null;
  setStatus: (newStatus: TestOrderStatus) => void;
}

export function TestOrderStatusDropdown(props: TestOrderStatusDropdownProps): JSX.Element {
  return (
    <SelectDropdown
      displayName={
        props.status != null ? <TestOrderStatusDisplay status={props.status} /> : 'Select new status'
      }
      className={css(styles.selectDropdown)}
      menu={
        <Menu width={Menu.WIDTHS.MEDIUM} height={Menu.HEIGHTS.MEDIUM}>
          {getOrderedTestOrderStatuses().map((status: TestOrderStatus) => (
            <Option key={status} onSelect={props.setStatus} value={status}>
              <TestOrderStatusDisplay status={status} />
            </Option>
          ))}
        </Menu>
      }
    />
  );
}

const styles = StyleSheet.create({
  selectDropdown: {
    paddingBottom: 16,
    width: 192,
  },
});
